<template>
	<AudioPlayerShell
		:data="data"
		:editable="editable"
		:active="active"
		:h5="h5"
		:id-key="idKey"
		@select="$emit('select')"
	/>
</template>

<script>
	import AudioPlayerShell from '../shared/AudioPlayerShell.vue';
	import { mediaBlockEmits, mediaBlockProps } from '../shared/mediaBlockProps.js';

	export default {
		name: 'GBlockAudioPlayer',
		components: { AudioPlayerShell },
		props: mediaBlockProps,
		emits: mediaBlockEmits,
	};
</script>
